function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../../locales/keys';
import { revokeGiftOrder, setRevokeGiftOrderModel } from './revoke.gift.order.actions';
import { IsRevokingGiftOrderSelector, RevokeGiftOrderErrorMessagesSelector, RevokeGiftOrderModelSelector } from './revoke.gift.order.selectors';
var RevokeGiftOrderDialogController = /*#__PURE__*/function () {
  function RevokeGiftOrderDialogController($ngRedux) {
    _classCallCheck(this, RevokeGiftOrderDialogController);
    this.$ngRedux = $ngRedux;
    this.LocaleKeys = LocaleKeys;
  }
  return _createClass(RevokeGiftOrderDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      this._connectRedux();
      this._persistState();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this._disconnectRedux();
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.formController.$setPristine();
      var onClose = this.onClose();
      onClose && onClose();
    }
  }, {
    key: "selectReasonCode",
    value: function selectReasonCode(reasonCode) {
      this.reasonCode = reasonCode;
      this._persistState();
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this = this;
      if (this.formController.$valid) {
        this._actions.revokeGiftOrder({
          reasonCode: this.state.revokeGiftOrderModel.reasonCode.id
        }, this.orderId).then(function () {
          _this.formController.$setPristine();
          var onSuccess = _this.onSuccess();
          onSuccess && onSuccess();
        });
      }
    }
  }, {
    key: "_connectRedux",
    value: function _connectRedux() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(state) {
        return {
          isRevokingGiftOrder: IsRevokingGiftOrderSelector(state),
          revokeGiftOrderErrorMessages: RevokeGiftOrderErrorMessagesSelector(state),
          revokeGiftOrderModel: RevokeGiftOrderModelSelector(state)
        };
      };
      var controllerActions = {
        revokeGiftOrder: revokeGiftOrder,
        setRevokeGiftOrderModel: setRevokeGiftOrderModel
      };
      this._disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2._actions = actions;
      });
    }
  }, {
    key: "_persistState",
    value: function _persistState() {
      this._actions.setRevokeGiftOrderModel({
        reasonCode: this.reasonCode || null
      });
    }
  }]);
}();
export default {
  bindings: {
    orderId: '<',
    reasonCode: '<',
    onClose: '&',
    onSuccess: '&'
  },
  controller: RevokeGiftOrderDialogController,
  template: require('./revoke.gift.order.dialog.html')
};